import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Select } from 'antd';
import styles from './index.module.less';
import { Message, Icon } from 'semantic-ui-react';
import Logo from '@/common/assets/images/WelcomePage.png';
// import bannertext from '@/common/assets/images/BannerText.svg';
import martrimonyLogo from '@/common/assets/images/LogoHeaer.png';
import FeatureCard from './FeatureCard';
import { useNavigate } from 'react-router-dom';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
// import ReCAPTCHA from 'react-google-recaptcha';
import verifiedIcon from '@/common/assets/images/verifiedIcon.png';
import privacyIcon from '@/common/assets/images/privacyIcon.png';
import inPersonIcon from '@/common/assets/images/inPersonIcon.png';
import heartLogo from '@/common/assets/images/heartLogo.png';
import aiLogo from '@/common/assets/images/aiLogo.png';
// import siteLogo from '../../../../common/assets/images/footerlogo.png';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Helmet } from 'react-helmet';
import SravanamasamOffer from './SravanamasamOffer'; // Import the offer component

const LoginPage = ({ get_profiles }) => {
  // , NewsTicker

  useEffect(() => {
    document.title =
      'Welcome to Elite Samskruti Matrimony - Find your perfect life partner';
  }, []);
  const [errorMsg] = useState('');
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = (values) => {
    // console.log('Form Values:', values);
    const { profileType } = values;

    let payload = {
      profileType
    };

    // console.log('payload', payload?.profileType);
    localStorage.setItem('profileType', payload?.profileType);
    // onSubmit(payload);

    if (payload?.profileType) {
      navigate('/register');
    }
  };

  const features = [
    {
      icon: verifiedIcon,
      title: '100% Verified profiles',
      description:
        'Fully screened profiles. Find matches by location, community, profession, and more from millions of active users.'
    },
    {
      icon: privacyIcon,
      title: 'Control your privacy',
      description:
        'Set boundaries for accessing your personal details and visual content.'
    },
    {
      icon: inPersonIcon,
      title: 'In-person vetted profiles',
      description:
        'Personally verified profiles. Our agents visit and verify, ensuring a special listing of trusted matches.'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Welcome to Elite Samskruti Matrimony</title>
        <meta
          name="description"
          content="Begin your journey to finding a life partner with Elite Samskruti Matrimony – where elite families meet their perfect match."
        />
        <meta
          name="keywords"
          content="welcome, elite matrimony, matchmaking, Indian marriage"
        />
        <link rel="canonical" href="https://elite.lexyslabs.com/welcome" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Elite Samskruti Matrimony | Welcome Page"
        />
        <meta
          property="og:description"
          content="Find your perfect match through India’s most trusted matchmaking platform."
        />
        <meta
          property="og:image"
          content="https://elite.lexyslabs.com/preview.jpg"
        />
        <meta property="og:url" content="https://elite.lexyslabs.com/welcome" />
        <meta property="og:type" content="website" />

        {/* Twitter Meta */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Elite Samskruti Matrimony" />
        <meta
          name="twitter:description"
          content="Where elite families find their perfect match."
        />
        <meta
          name="twitter:image"
          content="https://elite.lexyslabs.com/preview.jpg"
        />
      </Helmet>

      <Row className={styles.mainContainerStyle}>
        {/* <div className="App">
          <NewsTicker
            styles={{ color: 'red', height: '30px', lineHeight: '30px' }}
          />
        </div> */}
        {/* Header banner commented out for Dinesh guidance */}
        {/* <div className="App" style={{ width: '100%' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#d20b0b',
              justifyContent: 'center'
            }}
          >
            <img src={siteLogo} alt="First Image" style={{ width: '70px' }} />
            <h3
              className={styles.h3styles}
              style={{ color: 'white', fontSize: '12px', margin: '0' }}
            >
               Limited-Time Offer! FIRST 1000 SUBSCRIPTIONS are GST FREE!
              Subscribe now and save—don`t miss out! 
              Limited-Time Offer! Get upto 50% OFF on your subscription —
              exclusive to the first 1000 subscribers. ✨ Subscribe now — don’t
              miss out!
            </h3>
          </div>
        </div> */}

        <Col xs={24} xl={16} md={12} sm={24} className={styles.mainlogo}>
          <img className={`${styles.left_logo}`} src={Logo} alt="Logo" />
          <div className={styles.textstyles}>
            <h2>THE TALE OF</h2>
            <h1>TWO</h1>
          </div>
        </Col>

        <Col xs={24} xl={8} sm={24} md={12} className={styles.sideheader}>
          <div className={styles.headerload}>
            <img
              src={martrimonyLogo}
              alt="matrimony logo"
              className={styles.logostyles}
            />
          </div>
          <div className={styles.headerstyles}>
            <div className={styles.sideheader1}>
              <h1 className={styles.headingsmall}>Uniting </h1>
              <h1 className={styles.someonestyles}>HEARTS</h1>
            </div>
            <div className={styles.sideheader2}>
              <h1 className={styles.headingsmall}> Honoring </h1>
              <h1 className={styles.someonestyles}>TRADITIONS</h1>
            </div>
          </div>

          <div className={styles.centerstyles}>
            <SravanamasamOffer />
          </div>

          <div className={styles.right_outer_container}>
            <Form
              form={form}
              layout="vertical"
              className={`ant-form ant-form-vertical mt-4 ${styles.form_width}`}
              onFinish={onFinish}
            >
              <Form.Item
                label={
                  <span className={styles.profileLabel}>
                    Create Profile for:
                  </span>
                }
                name="profileType"
                rules={[
                  { required: true, message: 'Please select a profile type!' }
                ]}
              >
                <Select
                  placeholder="Select a profile type"
                  className={styles.profileSelect}
                  dropdownClassName={styles.customDropdown}
                >
                  {get_profiles?.length
                    ? get_profiles?.map((profile, index) => {
                        return (
                          <option value={profile?.id} key={index}>
                            {profile?.profile_for_type}
                          </option>
                        );
                      })
                    : ''}
                </Select>
              </Form.Item>

              <FormItem>
                <div style={{ textAlign: 'center' }}>
                  <CustomButton
                    block
                    type="primary"
                    htmlType="submit"
                    className={`${styles.login_button} flex items-center justify-center gap-2 text-center`}
                  >
                    Register Now
                  </CustomButton>
                </div>
                <div className={styles.centerstyles}>
                  <a href="/login">Already a member?</a>
                </div>
              </FormItem>
            </Form>
          </div>
        </Col>
      </Row>

      {/* Second Container */}
      <Row className={styles.secondContainerStyle}>
        <Col xs={24} xl={24} md={24} sm={24} className={styles.backgroundImg}>
          {/* <img className={`${styles.left_logo1}`} src={bannertext} /> */}
          <h2>Saha navavatu, saha nau bhunaktu, saha viryam karavavahai |</h2>

          <h2>।Tejasvinavadhitamastu ma vidvisavahai॥||</h2>
        </Col>

        <Col className={styles.featuressection}>
          {features.map((feature, index) => (
            <React.Fragment key={index}>
              <FeatureCard {...feature} />
              {index < features.length - 1 && (
                <div className={styles.dividerline} />
              )}
            </React.Fragment>
          ))}
        </Col>

        <Col className={styles.thirdcontainer}>
          <div className={styles.card}>
            <img
              src={heartLogo}
              alt="Heart Logo"
              className={styles.heartlogostyles}
            />
            <p className={styles.sanskritstyles}>yathecchasi tatha kuru |</p>
          </div>
          <div className={styles.textContainerstyles}>
            <h1 className={styles.headlinestyles}>We believe in connecting</h1>
            <h2 className={styles.subheadlinestyles}>
              HEARTS THAT BEAT IN HARMONY
            </h2>
            <p className={styles.paragraphstyles}>
              We honor the deep spiritual roots of Hindu marriage while
              embracing a more inclusive future. Our platform celebrates the
              sacred bond of marriage by focusing on what truly matters – the
              connection between two souls, their shared values, and their
              commitment to dharma.
            </p>
            <p className={styles.footerstyles}>
              Join our inclusive community where compatibility and genuine
              connections matter most.
            </p>
          </div>
        </Col>
        {/* forth Containers */}
        <Col className={styles.forthContainerstyles}>
          <div className={styles.textSectionstyles}>
            <h1 className={styles.titlestyles}>AI-DRIVEN MATCH</h1>
            <h2 className={styles.subtitlestyles}>
              recommendations tailored to suit your preferences
            </h2>
            {/* <div className={styles.borderline}></div> */}
            <p className={styles.descriptionstyles}>
              Discover personalized match suggestions tailored to your unique
              preferences, powered by advanced AI technology for a seamless,
              <br />
              thoughtful experience
            </p>
            <p className={styles.footer4styles}>
              Unlock personalized, AI-driven matches to find the person who
              complements you perfectly !!
            </p>
          </div>
          <div className={styles.imageSectionstyles}>
            <img src={aiLogo} alt="AI Logo" className={styles.aiLogostyles} />
          </div>
        </Col>
      </Row>

      <div>
        {errorMsg && (
          <Message negative>
            <Icon name="warning" />
            {errorMsg}
          </Message>
        )}
      </div>
    </>
  );
};

export default LoginPage;
